/* ==========================================================================
  main.js
========================================================================== */

"use strict";

/* global Swiper, object_vars */

const homeDestinationsSlider = () => {
  const homeSliderEl = document.querySelector(".home-slider");

  if (!homeSliderEl) {
    return;
  }

  const homeSlider = new Swiper(".home-slider", {
    slidePerView: 1,
    effect: "fade",
    navigation: {
      disabledClass: "home-slider__controls--disabled",
      nextEl: ".home-slider__controls--next",
      prevEl: ".home-slider__controls--prev",
    },
  });

  const cities = document.getElementsByClassName("city-navigation__item");

  if (cities.length > 0) {
    let current = cities[0];

    for (let i = 0; i < cities.length; i++) {
      initCities(cities[i], i);
    }

    function initCities(city, index) {
      city.addEventListener("mouseover", function () {
        homeSlider.slideTo(index);
      });
    }

    homeSlider.on("slideChange", function () {
      const city = cities[homeSlider.activeIndex];

      if (city) {
        if (current) {
          current.classList.remove("city-navigation__item--active");
        }

        city.classList.add("city-navigation__item--active");
        current = city;
      }
    });
  }
};

const switchContactPage = () => {
  const switcher = document.getElementById("switchVilleContact");

  if (!switcher) {
    return;
  }

  // on select change, retrive the value of the selected option then go to the corresponding page
  const urls = object_vars.contactPages;
  console.log(urls);

  switcher.addEventListener("change", function () {
    const selected = switcher.options[switcher.selectedIndex].value;

    console.log(selected);

    if (selected !== "") {
      urls.forEach(function (url) {
        if (url.label === selected) {
          window.location.href = url.value;
        }
      });
    }
  });
};

document.addEventListener("DOMContentLoaded", () => {
  homeDestinationsSlider();
  switchContactPage();
});

function scrollRotate() {
  const image = document.getElementById("floatingBooking");

  if (image == null) return;

  let rotate_scroll = window.scrollY;
  rotate_scroll = rotate_scroll / 100;
  rotate_scroll = rotate_scroll / 7;

  image.style.transform = "rotate(" + rotate_scroll + "rad)";
}

window.onscroll = function () {
  scrollRotate();
};

const fixedElement = document.querySelector(".floating-item");
const container = document.querySelector(".floating-container");

function checkPosition() {
  const containerRect = container.getBoundingClientRect();
  const fixedElementRect = fixedElement.getBoundingClientRect();

  if (
    fixedElementRect.bottom >= containerRect.top &&
    fixedElementRect.top <= containerRect.bottom
  ) {
    fixedElement.classList.remove("is-outside");
  } else {
    fixedElement.classList.add("is-outside");
  }
}

if (fixedElement) {
  window.addEventListener("DOMContentLoaded", checkPosition);
  window.addEventListener("scroll", checkPosition);
}
